import { format, parseISO } from 'date-fns';

export const toDateInputValue = (dateTime?: string): string => {
  if (!dateTime) return format(new Date(), 'yyyy-MM-dd');
  try {
    return format(parseISO(dateTime), 'yyyy-MM-dd');
  } catch {
    const datePart = dateTime.includes('T') ? dateTime.split('T')[0] : dateTime.slice(0, 10);
    return datePart || format(new Date(), 'yyyy-MM-dd');
  }
};

const extractTimeParts = (dateTime?: string): { hours: string; minutes: string } => {
  const now = new Date();
  const fallback = {
    hours: String(now.getHours()).padStart(2, '0'),
    minutes: String(now.getMinutes()).padStart(2, '0'),
  };
  if (!dateTime) return fallback;

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(dateTime)) {
    const [, timePart] = dateTime.split('T');
    const [hours, minutes] = timePart.slice(0, 5).split(':');
    return { hours: hours.padStart(2, '0'), minutes: minutes.padStart(2, '0') };
  }

  try {
    const parsed = parseISO(dateTime);
    return {
      hours: String(parsed.getHours()).padStart(2, '0'),
      minutes: String(parsed.getMinutes()).padStart(2, '0'),
    };
  } catch {
    return fallback;
  }
};

/** Merge a new calendar date with the time from an existing datetime-local value. */
export const mergeDateWithExistingTimeLocal = (newDateYmd: string, existingDateTime?: string): string => {
  const { hours, minutes } = extractTimeParts(existingDateTime);
  return `${newDateYmd}T${hours}:${minutes}`;
};

/** Merge a new calendar date with the time from an existing ISO datetime. */
export const mergeDateWithExistingTimeIso = (newDateYmd: string, existingIso?: string): string => {
  const [year, month, day] = newDateYmd.split('-').map(Number);
  const base = existingIso ? parseISO(existingIso) : new Date();
  const merged = new Date(base);
  merged.setFullYear(year, month - 1, day);
  return merged.toISOString();
};
